var $ = require('jquery')

var defaults = {
    ignoreAdvertise: true
  , autoPlay: true
  , width: '100%'
  , height: '100%'
}

var Video = function(options) {
  $.extend(this, defaults, options || {})
}

var videoTmpl = require('./tmpl.handlebars')

Video.prototype.getFlashParams = function() {
  var paramsArray = []
  if (this.autoPlay) {
    paramsArray.push('m16=1')
  }

  if (this.ignoreAdvertise) {
    paramsArray.push('m10=0')
    paramsArray.push('m12=1')
  }

  return paramsArray.join('&')
}

Video.prototype.getVideoCode = function() {
  return (this.videoUrl).replace(/(.*\/)*([^.]+).*/ig,"$2");
}

Video.prototype.getIframeUrl = function() {
  return '//v.17173.com/player_ifrm2/'+ this.getVideoCode() +'.html?'+ this.getFlashParams() +''
}

Video.prototype.toHTML = function() {
  return videoTmpl({
    width: this.width
  , height: this.height
  , url: this.getIframeUrl()
  })
}

module.exports = Video
